// extracted by mini-css-extract-plugin
module.exports =  {"chartAxisG":"PriceChangeAxes-module__chartAxisG--WOd63"};